import { CircleAlert } from 'lucide-react';
import Image from 'next/image';

const NoDataCard = ({
  text = 'Одоогоор мэдээ, мэдээлэл оруулаагүй байна',
  image = '',
}: {
  text?: string;
  image?: string;
}) => {
  return (
    <div className="flex flex-col items-center h-full p-4 text-gray-400">
      {image ? (
        <Image src={image} alt="No data" width={64} height={64} />
      ) : (
        <CircleAlert size={64} />
      )}
      <p className="text-sm font-medium">{text}</p>
    </div>
  );
};

export default NoDataCard;
